import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import useAuthRedirect from '../hooks/useAuthRedirect';
import SidebarSteps from '../components/SidebarSteps';
function Modal({ message, onClose }) {
   const handleOverlayClick = (e) => {
      if (e.target.className === 'modal_overlay') {
         onClose();
      }
   };
   return (
      <div className="modal_overlay" onClick={handleOverlayClick}>
         <div className="modal_content">
            <div className="modal_content_header">
               <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            <div className="modal_content_body d-flex flex-column">
               <p>{message}</p>
               <span onClick={onClose} className="ppt_btn_primary ms-auto alt">Accept</span>
            </div>
         </div>
      </div>
   );
}
function SignUp() {
   useAuthRedirect();
   const [showModal, setShowModal] = useState(false);
   const [modalMessage, setModalMessage] = useState('');
   function register() {
      console.log('Register');
      var email = document.querySelector('input[type=email]').value;
      var password = document.querySelector('input[type=password]').value;
      console.log(email, password);
      if (email === '' || password === '') {
         setModalMessage('Please complete all fields');
         setShowModal(true);
      } else {
         console.log('Registration successful');
         fetchAPI(email, password);
      }
   }
   function fetchAPI(email, password) {
      fetch('https://pt-api.digit-a.net/api/auth/register', {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
         },
         body: JSON.stringify({
            "email": email,
            "password": password
         })
      })
         .then(response => response.json())
         .then(json => {
            console.log('Respuesta completa del API:', json); // Mantener este log para debug
            if (json.error && json.error.includes('error')) {
               setModalMessage('This email address is already registered. \n Please use another email address.');
               setShowModal(true);
            } else {
               console.log('Token de validación:', json.payload?.tokenValidation);
               localStorage.setItem('demoToken', json.payload?.tokenValidation || '');
               localStorage.setItem('userEmail', email); // Guardamos el email
               window.location.href = '/sign-up-2';
            }
         })
         .catch(error => {
            console.error('Error:', error);
            setModalMessage('An error occurred during registration. Please try again.');
            setShowModal(true);
         });
   }
   useEffect(() => {
      localStorage.clear();
   }, []);
   return (
      <>
         {showModal && (
            <Modal
               message={modalMessage}
               onClose={() => setShowModal(false)}
            />
         )}
         <div className="container" page-key="signup">
            <div className="row">
               <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
                  <span className="mt-auto d-lg-none">
                     <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                  </span>
                  <DarkModeBtn />
               </div>
               <div className="col-12">
                  <div className="d-flex flex-column align-items-center d-lg-none w-100 gap-2 mb-3">
                     <h1>Sign Up</h1>
                     <SidebarSteps activeStep={1} />
                  </div>
                  <nav className="ppt_log mb-4 mb-lg-5">
                     <NavLink to="/sign-in">Sign In</NavLink>
                     <NavLink to="/sign-up">Sign Up</NavLink>
                  </nav>
                  <form className="ppt_form signIn">
                     <h3 className="ppt_form_title mb-3 text-center text-lg-start">Sign up details</h3>
                     <p className="smallMe mb-0">You must create a ProperT account details to buy, sell, or hold digital assets.</p>
                     <p className="smallMe mb-4 mb-lg-5">We'll ask you a little about yourself and to get you started.</p>
                     <div className="ppt_input_style mb-4">
                        <label>Email</label>
                        <div><input type="email" className="form-control" /></div>
                     </div>
                     <div className="ppt_input_style mb-4">
                        <label>Password</label>
                        <div><input type="password" className="form-control" /></div>
                     </div>
                     <div className="ppt_input_style mb-3 mb-lg-5">
                        <span className="ppt_btn_primary" onClick={register}>Next</span>
                        {/* <NavLink to="/sign-up-2" className="ppt_btn_primary">Next</NavLink> */}
                     </div>
                     <div className="ppt_gen_msg mb-4">
                        <p className="mb-0">If you are looking to recover your individual wallet, click <NavLink to="/recovery-phrase">here</NavLink> to use your recovery phrase.</p>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </>
   );
}
export default SignUp;